// extracted by mini-css-extract-plugin
export default {"searchResults":"bx_gN","resultsMessage":"bx_gP","breadcrumb":"bx_gQ","isOpen":"bx_fN","hitCount":"bx_gR","hasResults":"bx_gS"};